<div class="flex flex-col gap-3 items-center w-full">
  <ion-label class="text-[11px] text-center mb-4 text-[#294d8faf] px-3">{{ 'CHAT.RETURN_ADVICE' | translate }}</ion-label>

  <!-- Iteramos por cada grupo de mensajes por fecha -->
  <div *ngFor="let group of messageGroups" class="w-full">
    <!-- Mostramos la fecha del grupo -->
    <div class="flex justify-center mb-2">
      <ion-label class="text-[10px] bg-[#f0f0f0] px-3 py-1 rounded-full text-[#294d8f]">
        {{ group.date }}
      </ion-label>
    </div>

    <!-- Iteramos por cada mensaje dentro del grupo -->
    <div *ngFor="let message of group.messages" class="w-full">
      <app-messages [message]="transformMessage(message)" (showImage)="forwardImage($event)"></app-messages>
    </div>
  </div>
</div>
